export default __webpack_public_path__ + "media/images/drawlogo_fr-0b7adf44e72849a5635fe542754fa603.png";